export default "__VITE_ASSET__B2Y3JLXQ__"